/* eslint-disable security/detect-object-injection */
/* eslint-disable max-len */
import { Menu } from '@headlessui/react'
import React, { useState } from 'react';
import NoteModal from './noteModal';
import config from '../../../config';
import { useNavigate } from 'react-router-dom'
import PublishAuctionModal from '../auctionView/publishAuctionModal';
import { dataService } from '../../../services/dataService';
import { useDispatch } from 'react-redux';
import { timeZoneMap } from '../../../CommonComponent/staticValues';
import moment from 'moment-timezone';
import { Auth } from 'aws-amplify';
import { logout } from '../../auth/registrationSlice';
import { clearData } from '../../account/profileSlice';
import PublishLiveAuctionModal from '../auctionView/PublishLiveAuctionModal';
import { getAuctionStatusClasses } from '../../../constant/auctionStatusClasses';
import scrollToTop from '../../../CommonComponent/scrollToTop';
import Modal from '../../../CommonComponent/Modal';

export default function TableRow(props){

    const { auction, addNoteHandler,cloneHandler,setAuctionInfo,auctionInfo,
        setIsDeleteModalOpen,setMessage, index,
        setIsCancelModalOpen, handleFetch, domain, fetchAuctions,setErrorMessage}= props;

    const [isOpenModal,setIsOpenModal]=useState(false);
    const [note, setNote]=useState('');
    const [fetchNote, setFetchNote]=useState('')
    const Navigate=useNavigate();
    const [auctionId, setAuctionId]=useState('');
    const plan_type=localStorage.getItem('plan_type');
    const [selectedRow, setSelectedRow]=useState(null);
    const noteRegex = /^(?!\s).*$/;
    const navigate = useNavigate()
    const [publishModalOpen, setPublishModalOpen] = useState(false);
    const [unpublishModalOpen,setUnpublishModalOpen]= useState(false); 
    const [publishLoader,setPublishLoader] = useState(false)
    const [isRequiredFieldEmpty, setIsRequiredFieldEmpty] = useState(false)
    const [isPublished, setIsPublished] = useState(false)
    const [noLot,setNoLot]=useState(false);
    const [notConnect, setNotConnect]=useState(null)
    const user = (localStorage.getItem('user'));

    const convertTimestampToDayMonthYear = (timestamp, time_zone) => {
        
        if(!timestamp || timestamp === '0' || !timestamp) {
            return '-';
        }
        const tz = moment.tz(timestamp, timeZoneMap[time_zone] || time_zone || 'Etc/GMT');
        const formatted = tz.format("DD MMM YYYY");
        
        return formatted.includes('1970') ? '-' : formatted;
    };

    /**
     * The saveHandler function is used to handle saving or deleting a note in a React component.
     */
    const saveHandler=(type)=>{
        if(type==='delete'){
            addNoteHandler(auctionId,'');
        }else{
            addNoteHandler(auctionId,note);
        }
        setIsOpenModal(false);
    }

    /**
     * The function `noteHandler` checks if a given note matches a regular expression and sets the note
     * if it does.
     * @returns If the note passes the test of the noteRegex, then the setNote function is called with
     * the note as an argument. If the note does not pass the test, nothing is returned.
     */
    const noteHandler=(note)=>{
        if(noteRegex.test(note)){
            setNote(note)
        }else{
            return;
        }
    }

    const publishConfirmation = auctionInfo.auction_type=="live" ? ((auctionInfo.auction_image =="" || auctionInfo.title=="" || auctionInfo.description=="" || auctionInfo.currency=="" ) || 
            (auctionInfo.start_date =="" || auctionInfo.time_zone==""  || auctionInfo.start_date ==null ) || 
            (auctionInfo.registration_type=="" || ((auctionInfo.add_buyer_fees =="Add percentage"  && auctionInfo.percentage=="") || ( auctionInfo.add_buyer_fees=="Add fixed fee" 
            && auctionInfo.fees=="" ) )) || auctionInfo.accept_absentee_bid==null || auctionInfo.accept_telephone_bid==null) : 
        ((auctionInfo.auction_image =="" || auctionInfo.title=="" || auctionInfo.description=="" || auctionInfo.currency=="" ) || 
            (auctionInfo.start_date =="" || auctionInfo.end_date=="" || (auctionInfo.time_zone=="" ) || auctionInfo.start_date ==null || auctionInfo.end_date==null ) || 
            (((auctionInfo.extension_type =="Cascade" || auctionInfo.extension_type =="Individual lots") 
            && auctionInfo.extension_time_between_lots=="") || auctionInfo.extension_time=="" || auctionInfo.registration_type=="" 
            || ((auctionInfo.add_buyer_fees =="Add percentage"  && auctionInfo.percentage=="") || ( auctionInfo.add_buyer_fees=="Add fixed fee" 
            && auctionInfo.fees=="" ) )));

    /**
     * The function `handlePublishAuction` is an asynchronous function that publishes an auction and
     * updates the state accordingly.
     */
    const handlePublishAuction = async(auctionId)=>{
        setPublishLoader(true);
        let data = {};

        const body = {
            "auction_id": auctionId,
            "seller_email": user
        }
        if(!publishConfirmation){

            if(auctionInfo.total_lots>0){
                if(auctionInfo.auction_type=="live"){
                    data = await dataService.PublishLiveAuction(body);
                }else{
                    data = await dataService.publishAuction(auctionId)
                }
                if(data.error==true){
                    const errorMessage = data.message.response.data.message;

                    switch (errorMessage) {
                    case "Auction is already published or is Accepting bids":
                    case "Auction not in draft state":
                        setErrorMessage('Auction is already in Published State')
                        setPublishModalOpen(false)
                        fetchAuctions()
                        setTimeout(() => {
                            setErrorMessage('')
                        }, 3000);
                        break;

                    case "Some lots are missing lot images":
                    case "No images found for this auction":
                        setPublishModalOpen(false)
                        setIsRequiredFieldEmpty(true)
                        setNoLot(true);
                        break;

                    case "Stripe or PayPal account is not linked.":
                        setNotConnect("stripe")
                        setPublishModalOpen(false)
                        setIsRequiredFieldEmpty(true)
                        break;

                    case "Unauthorised to perform this action.":
                        Auth.signOut();
                        dispatch(logout());
                        dispatch(clearData());
                        localStorage.clear()
                        Navigate('/login')
                        break;

                    default:
                        if(errorMessage.includes("verification")){
                            setNotConnect("verification")
                            setPublishModalOpen(false)
                            setIsRequiredFieldEmpty(true)
                        }else{
                            setErrorMessage(errorMessage)
                            setPublishModalOpen(false)
                            setTimeout(() => {
                                setErrorMessage('')
                            }, 30000);
                        }
                    }
                }else{
                    setErrorMessage("")
                    setIsPublished(true)
                    setPublishModalOpen(false)
                    setPublishLoader(false)
                    fetchAuctions()
                }
            }else{
                setPublishModalOpen(false)
                setIsRequiredFieldEmpty(true)
            }
        }else{
            setPublishModalOpen(false)
            setIsRequiredFieldEmpty(true)
        }
        setPublishLoader(false)
    }

    const handleTemplate=(template)=>{
        if(template==="Classic"){
            localStorage.setItem('selectedTemplateId','1')
            return "classic";
        }else if(template==="" || template==="Single lot" || template==="Single Lot"){
            localStorage.setItem('selectedTemplateId','2')
            return "single-lot";
        }else if(template==="Standalone"){
            localStorage.setItem('selectedTemplateId','3')
            return "standalone";
        }
    }

    const dispatch=useDispatch();

    const handleUnpublishAuction = async()=> {
        setPublishLoader(true)
        let body={
            "type": "UNPUBLISH"
        }
        let data = {};
        if(auctionInfo.auction_type=="live"){
            body = {
                "auction_id": auctionInfo.auction_id,
                "seller_email": user
            }
            data = await dataService.UnpublishLiveAuction(body);
        }else{
            data = await dataService.UnpublishAuction(auctionInfo.auction_id, body)
        }
        
        setUnpublishModalOpen(false)
        setPublishLoader(false)
        scrollToTop();
        if(data.error==true){
            if(data?.message?.response?.data?.message){
                setErrorMessage(data?.message?.response?.data?.message)
                setTimeout(()=>{
                    setErrorMessage("")
                },30000)
            }else{
                setErrorMessage('Something went wrong. Please try again')
                setTimeout(()=>{
                    setErrorMessage("")
                },3000)
            }
        }else{
            setErrorMessage('');
            setMessage('Auction unpublished successfully')
            setTimeout(()=>{
                setMessage("")
            },3000)
        }
        handleFetch();
    }

    const handleSingleAuctionInfo = async(index,auction)=>{
        const data = await dataService.viewAuction(`?auction_id=${auction._id}`)
        const auctionInfo = data?.data?.data;
        setSelectedRow(index)
        setAuctionInfo(auctionInfo)
        setNoLot(false)
        setNotConnect(null)
    }

    const auction_image =(auction)=>{ 
        return Array.isArray(auction.auction_image) ? auction.auction_image.find((image) => image.featured).url : auction.auction_image };

    return(
        <>
            <tr
                className={`table-row  h-14
                    hover:bg-[#F4F4F5] ${selectedRow===index ? 'bg-[#F4F4F5]' : ''} `}>
                <td className="text-[#343434] px-4 py-3 text-[16px] leading-normal font-medium border-b border-[#DEDEDE]">
                    {auction.auction_id}</td>
                <td className='border-b border-[#DEDEDE]'>
                    <img width={20} height={20} className="mx-auto"
                        title={` ${(auction.auction_type=="live") ? 'Live Auction' : 'Timed Auction'} `}
                        src={` ${(auction.auction_type=="live") 
                            ? '/images/gavel.svg' : '/images/schedule.svg'} `} alt="img" loading='lazy' />
                </td>
                <td className='border-b border-[#DEDEDE]' ><img 
                    src={` ${(auction.auction_image===undefined || auction.auction_image==='') 
                        ? '/images/auction-img1.png' : `${config.Storage.CDN}${auction_image(auction)}`} `}
                    className="px-4 py-3 w-[95px] h-[77px]" alt="img" loading='lazy' /></td>
                <td 
                    className="text-[#343434] px-4 py-3 text-[16px] text-center leading-normal 
                    font-medium cursor-pointer hover:underline max-w-[200px] truncate border-b border-[#DEDEDE]"
                    title={auction.title}
                    onClick={() => navigate(`/auctions/${auction._id}/${auction.auction_id}/overview`, {
                        state: auction.auction_id
                    })} >
                    {auction.title==='' ? '-' : auction.title}</td>
                <td className="text-[#343434] px-4 py-3 text-[16px] text-center leading-normal font-medium border-b border-[#DEDEDE]">
                    {(auction.start_date===null || auction.start_date==='')  ? '-' : convertTimestampToDayMonthYear(auction.start_date, auction.time_zone)}</td>
                <td className="text-[#343434] px-4 py-3 text-[16px] text-center leading-normal font-medium border-b border-[#DEDEDE]">
                    {(auction.end_date===null || auction.end_date==='') ? '-' : convertTimestampToDayMonthYear(auction.end_date, auction.time_zone)}</td>
                <td className="px-4 py-3 border-b border-[#DEDEDE]">
                    <div className="flex justify-center">
                        <span className={` ${getAuctionStatusClasses(auction.status)}
                            py-[8px] px-[16px] text-[12px]  
                            rounded-[42px] text-end leading-normal font-semibold`}>{auction.status}</span>
                    </div>
                </td>
                    
                {(auction.note!==undefined && auction.note!=='') ?
                    <td className="text-[#343434] py-3 text-[16px] text-center leading-normal font-medium mx-auto border-b border-[#DEDEDE]"
                        onClick={()=>{setIsOpenModal(true); setAuctionId(auction.auction_id); 
                            setFetchNote(auction.note)}}>
                        <img id='view-note' data-testid="view-note" src="/images/draft-note.svg" className=" cursor-pointer" alt="img"
                            data-te-toggle="modal"
                            data-te-target="#exampleModal2"
                                            
                            data-te-dropdown-item-ref />
                    </td>:
                    <td className="text-[#343434] px-4 py-3 text-[16px] text-center leading-normal font-medium border-b border-[#DEDEDE]">
                    </td>
                }
                <td className="sm:relative  sm:bg-transparent bg-[#fff] sticky right-0 border-b border-[#DEDEDE]">
                    <div className="h-fit py-[43px] sm:shadow-none shadow-bs7 sm:px-4 px-2">
                        <span className="flex justify-end">
                            <Menu as="div" className="relative" >
                                <Menu.Button onClick={()=>{handleSingleAuctionInfo(index, auction)}} >
                                    <img src="/images/three-dots-icon-black.svg" alt="img" 
                                        className="cursor-pointer three-dots-icon action-bar" type="button"
                                        id="dropdownMenuButton1" data-testid={`action-bar-${index}`} />
                                </Menu.Button>
                                <Menu.Items>
                                    <div className="dropdown-cont absolute overflow-hidden rounded-[10px] float-left 
                                                    m-0 w-[150px] py-2 min-w-max right-0 z-[50] 
                                                    list-none  border-none bg-white bg-clip-padding 
                                                    text-left text-base shadow-bs3 px-2">
                                        <Menu.Item data-testid='view-auction' className="px-2" >
                                            <button type='button'
                                                onClick={() => {navigate(`/auctions/${auction._id}/${auction.auction_id}/overview`, {
                                                    state: auction.auction_id
                                                })}}
                                                className="block w-full whitespace-nowrap bg-transparent pl-3 pr-5 py-2
                                                            text-[12px] font-medium text-[#343434] text-left hover:bg-[#E6E6E6] hover:rounded-[11px]">
                                                View Details</button>
                                        </Menu.Item>
                                        <Menu.Item>
                                            <button type='button' data-testid="publish-auction"
                                                disabled={auction.status=='Cancelled' || auction.status=="Accepting bids" || auction.status=="Completed" || auction.status=="In Progress"}
                                                onClick={() => {
                                                    auction.status==='Published' ? setUnpublishModalOpen(true) : setPublishModalOpen(true)
                                                }}
                                                className="block w-full whitespace-nowrap bg-transparent pl-3 pr-5 py-2 
                                                            text-[12px] font-medium text-[#343434] text-left hover:bg-[#E6E6E6] hover:rounded-[11px]
                                                            disabled:cursor-auto  disabled:text-[hsl(240,4%,65%)]">
                                                {auction.status==='Published'?'Unpublish':'Publish'}</button>
                                                
                                        </Menu.Item>
                                        <Menu.Item  id='edit-auction'>
                                            <button 
                                                disabled={auction.status=='Completed' || auction.status =='Cancelled' || auction.status =='In Progress'}
                                                onClick={(e)=>{
                                                    e.preventDefault();
                                                    const path = `/auctions/${auction.auction_type ? 'live' : 'timed'}/edit/${auction._id}/${auction.auction_id}/${handleTemplate(auction.template_name)}`;
                                                    Navigate(path, {state: {start_date: auction.start_date, end_date: auction.end_date, location: auction.location}});
                                                }}
                                                className="block w-full whitespace-nowrap bg-transparent pl-3 pr-5 py-2 hover:bg-[#E6E6E6] hover:rounded-[11px]
                                                            text-[12px] font-medium text-[#343434] text-left disabled:text-[hsl(240,4%,65%)] disabled:cursor-auto">Edit</button>
                                        </Menu.Item>
                                        {(auction.status!=="Accepting bids" && auction.status!=="Cancelled" && auction.status!=="In Progress") && <Menu.Item>
                                            <button  disabled={plan_type.includes("Free")}  
                                                data-testid="clone-auction"
                                                onClick={()=>cloneHandler(auction._id)}
                                                className="disabled:text-[hsl(240,4%,65%)] disabled:cursor-auto block 
                                                        w-full whitespace-nowrap bg-transparent pl-3 pr-5 text-left hover:bg-[#E6E6E6] hover:rounded-[11px]
                                                            py-2 text-[12px] font-medium text-[#343434] cursor-pointer"
                                            >Clone</button>
                                        </Menu.Item>}
                                        <Menu.Item>
                                            <p
                                                onClick={()=>{setIsOpenModal(true); setAuctionId(auction.auction_id); 
                                                    setFetchNote(auction.note)}}
                                                data-testid="add-note"
                                                className="block w-full whitespace-nowrap bg-transparent pl-3 pr-5 py-2 
                                                            text-[12px] font-medium text-[#343434] cursor-pointer hover:bg-[#E6E6E6] hover:rounded-[11px]"
                                            >{(auction.note===undefined || auction.note==='') ? 'Add Note' 
                                                    : 'Delete Note'}</p>
                                        </Menu.Item>
                                        <Menu.Item>
                                            {(auction.status!=='Accepting bids' && auction.status!=='In Progress')?
                                                <button 
                                                    disabled={auction.status==="Accepting bids" || 
                                                        auction.status==="In Progress" || (auction.status !=="Draft" && auction.auction_type==="live") ||
                                                        auction.status==='Completed'}
                                                    data-testid="delete-auction"
                                                    onClick={()=>{setIsDeleteModalOpen(true)}}
                                                    className="disabled:text-[hsl(240,4%,65%)] disabled:cursor-auto block 
                                                        w-full whitespace-nowrap bg-transparent pl-3 pr-5 text-left hover:bg-[#E6E6E6] hover:rounded-[11px]
                                                            py-2 text-[12px] font-medium text-[#343434] cursor-pointer 
                                                            delete-auction"
                                                >Delete</button>
                                                :
                                                <button 
                                                    type='button'
                                                    data-testid="deactivate"
                                                    onClick={()=>{setIsCancelModalOpen(true)}}
                                                    className="disabled:text-[hsl(240,4%,65%)] disabled:cursor-auto block 
                                                    w-full whitespace-nowrap bg-transparent pl-3 pr-5 text-left hover:bg-[#E6E6E6] hover:rounded-[11px]
                                                        py-2 text-[12px] font-medium text-[#343434] cursor-pointer 
                                                        delete-auction"
                                                >Cancel</button>}
                                        </Menu.Item>
                                    </div>
                                </Menu.Items>
                            </Menu>
                        </span>  
                    </div> 
                </td>
            </tr>
            
            {isOpenModal && 
            <NoteModal setIsOpenModal={setIsOpenModal} isOpenModal={isOpenModal}>
                <div className="relative sm:mx-8 mx-5 mb-5">
                    {(fetchNote==='' || fetchNote===undefined) && 
                        <p className="pb-1 mt-8 leading-normal text-[12px]  text-[#343434] 
                                         font-medium">Add notes</p>}
                    {(fetchNote==='' || fetchNote===undefined) ? 
                        <textarea id='text-area' name="text-area" onChange={(e)=>{noteHandler(e.target.value)}}
                            className="resize-none outline-none w-full h-[120px] px-2 
                                        py-2.5 overflow-y-auto overflow-x-hidden customScrollbar border border-[#A1A1A9] 
                                        placeholder:text-[14px] placeholder:text-[#A1A1A9] text-[16px] leading-normal 
                                        font-medium text-[#343434]" placeholder="Type here"  cols="10" rows="10"
                            value={note}>
                            {note}</textarea> : 
                        <p name="text-area"
                            className="resize-none outline-none mt-6 w-full px-4 break-all 
                                        py-2.5 overflow-y-auto overflow-x-hidden customScrollbar 
                                        placeholder:text-[14px] text-[16px] leading-normal 
                                        font-medium text-[#343434]">
                            {fetchNote}</p>}
                    <div className="flex justify-center mt-3">
                        <button id='save-note' data-testid='save-note' disabled={(fetchNote==='' || fetchNote===undefined) && note==""}
                            className={` ${(fetchNote==='' || fetchNote===undefined) ? 'bg-[#282828] text-[#FFFFFF]' : 
                                'bg-[#fff] border border-[#A1A1A9] text-[#52525A]'} 
                        px-[31px] py-[12px] leading-normal font-medium text-[14px] rounded-[6px] disabled:bg-[#D4D4D8] disabled:text-[hsl(240,4%,65%)] `} 
                            onClick={()=>saveHandler((fetchNote==='' || fetchNote===undefined) ? 'save' : 'delete')}>
                            {(fetchNote==='' || fetchNote===undefined) ? 'Save' : 'Delete note'}
                        </button>
                    </div>
                </div> 
            </NoteModal>}
            
            {auctionInfo.auction_type!=="live" ? 
                <PublishAuctionModal notConnect={notConnect} publishModalOpen={publishModalOpen} setPublishModalOpen={setPublishModalOpen} 
                    handlePublishAuction={handlePublishAuction} loader={publishLoader} selectedId={auctionInfo.auction_id}
                    auctionData={auctionInfo} isRequiredFieldEmpty={isRequiredFieldEmpty} domain={domain} noLot={noLot}
                    setIsRequiredFieldEmpty={setIsRequiredFieldEmpty} isPublished={isPublished} setIsPublished={setIsPublished} />
            
                :
                <PublishLiveAuctionModal notConnect={notConnect} publishModalOpen={publishModalOpen} setPublishModalOpen={setPublishModalOpen} 
                    handlePublishAuction={handlePublishAuction} loader={publishLoader} selectedId={auctionInfo.auction_id}
                    auctionData={auctionInfo} isRequiredFieldEmpty={isRequiredFieldEmpty} domain={domain} noLot={noLot}
                    setIsRequiredFieldEmpty={setIsRequiredFieldEmpty} isPublished={isPublished} setIsPublished={setIsPublished} />
            }

            <Modal isOpen={unpublishModalOpen} setIsOpen={setUnpublishModalOpen} loading={publishLoader}
                title="Are you sure you want to unpublish this auction?" close={true} 
                handleAction={handleUnpublishAuction} buttonText="Unpublish" testid="unpublish"
            />

        </>
    );
}